interface Props {
  size?: number;
  className?: string;
}

/**
 * Stylized globe with a "Barfußroute" — the trade-wind sailing route around
 * the world (roughly 30°N–30°S, looping through the tropics).
 *
 *   - Pale circle = ocean
 *   - Schematic continents (very simplified blob outlines)
 *   - Red dashed sweep = the route, with a small boat marker on it
 */
export default function Globe({ size = 96, className = "" }: Props) {
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Barfußroute Globus"
    >
      {/* Ocean */}
      <circle cx="60" cy="60" r="52" fill="#0e7490" fillOpacity="0.15" stroke="#22d3ee" strokeOpacity="0.4" strokeWidth="0.7" />

      {/* Latitude/longitude grid */}
      <g stroke="#94a3b8" strokeOpacity="0.18" fill="none" strokeWidth="0.5">
        <ellipse cx="60" cy="60" rx="52" ry="14" />
        <ellipse cx="60" cy="60" rx="52" ry="28" />
        <ellipse cx="60" cy="60" rx="52" ry="42" />
        <ellipse cx="60" cy="60" rx="14" ry="52" />
        <ellipse cx="60" cy="60" rx="28" ry="52" />
        <ellipse cx="60" cy="60" rx="42" ry="52" />
      </g>

      {/* Equator (slightly thicker) */}
      <line x1="8" y1="60" x2="112" y2="60" stroke="#22d3ee" strokeOpacity="0.35" strokeWidth="0.7" />

      {/* Schematic continents (stylized blobs, not geographically accurate) */}
      <g fill="#94a3b8" fillOpacity="0.55">
        {/* Americas */}
        <path d="M28 36 Q 24 50, 30 60 Q 28 72, 34 84 Q 36 92, 30 96 Q 24 88, 22 76 Q 18 62, 22 52 Q 24 42, 28 36 Z" />
        {/* Africa + Europe */}
        <path d="M58 28 Q 64 32, 64 42 Q 70 44, 70 52 Q 68 64, 60 74 Q 56 80, 54 76 Q 50 70, 52 60 Q 50 50, 54 42 Q 54 34, 58 28 Z" />
        {/* Asia */}
        <path d="M76 32 Q 90 30, 96 42 Q 98 50, 94 56 Q 90 60, 84 58 Q 80 56, 78 50 Q 74 42, 76 32 Z" />
        {/* Australia */}
        <path d="M86 70 Q 96 70, 98 78 Q 96 84, 88 84 Q 82 80, 86 70 Z" />
      </g>

      {/* Barfußroute — westwards loop through tropics */}
      <path
        d="M 30 64 C 20 64, 18 52, 36 50 C 56 50, 70 52, 86 56 C 102 60, 102 70, 90 72 C 70 74, 50 72, 32 70"
        fill="none"
        stroke="#ef4444"
        strokeWidth="1.6"
        strokeDasharray="2.5 2"
        strokeLinecap="round"
      />

      {/* Boat marker partway along the route */}
      <g transform="translate(64, 53.5)">
        <circle r="3" fill="#ef4444" />
        <circle r="2" fill="#fef2f2" />
      </g>
    </svg>
  );
}
